import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_GATEWAY_URL
})

axiosInstance.defaults.headers.common["x-api-key"] = process.env.REACT_APP_API_GATEWAY_KEY
axiosInstance.defaults.headers.post["Content-Type"] = "application/json"

export default axiosInstance